import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Settings, Puzzle, Rocket, CheckCircle } from 'lucide-react'

const CustomSoftware = () => {
  const features = [
    {
      icon: <Settings className="w-6 h-6" data-component-path="client/src/pages/services/CustomSoftware.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/CustomSoftware.jsx:7:12" />,
      title: 'Tailored Solutions',
      description: 'Built specifically for your unique workflows'
    },
    {
      icon: <Puzzle className="w-6 h-6" data-component-path="client/src/pages/services/CustomSoftware.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/CustomSoftware.jsx:13:12" />,
      title: 'System Integration',
      description: 'Seamless connection with existing tools'
    },
    {
      icon: <Rocket className="w-6 h-6" data-component-path="client/src/pages/services/CustomSoftware.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/CustomSoftware.jsx:19:12" />,
      title: 'Rapid Development',
      description: 'Agile methodology for faster delivery'
    },
    {
      icon: <CheckCircle className="w-6 h-6" data-component-path="client/src/pages/services/CustomSoftware.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/CustomSoftware.jsx:25:12" />,
      title: 'Quality Assurance',
      description: 'Rigorous testing for bug-free software'
    },
  ]

  return (
    <ServiceTemplate
      title="Custom Software Development"
      subtitle="Bespoke software solutions designed for your exact requirements"
      description="Transform your unique business challenges into competitive advantages with custom software built from the ground up. We deliver tailored solutions that integrate seamlessly with your existing systems and scale with your growth."
      features={features}
      heroImage="https://images.pexels.com/photos/1181263/pexels-photo-1181263.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default CustomSoftware